import { Client } from 'api/client/types';

export enum ClientTypes {
  individualPerson = 'individualPerson',
  legalPerson = 'legalPerson',
}

export type AddOption = { type: 'add'; value: string };
export type ClientSearchOption = AddOption | Client;
